import { isAxiosError } from 'axios';
import type { TFunction } from 'i18next';
import { z } from 'zod';

const validationErrorSchema = z.object({
  errors: z.record(z.string(), z.array(z.string())),
});
const fields = [
  'product',
  'productWeight',
  'productHsCode',
  'materials',
  'materialEnglishName',
  'materialHsCode',
  'materialCommonName',
  'materialScientificName',
] as const;

export function getProductionDeclarationDataError(
  error: unknown,
  t: TFunction,
): string | undefined {
  if (!isAxiosError(error) || error.response?.status !== 422) {
    return;
  }
  const parsed = validationErrorSchema.safeParse(error.response.data);
  if (!parsed.success) {
    return;
  }
  const details = fields.flatMap((field) => {
    const references = parsed.data.errors[`productionDeclarationData.${field}`];
    return references?.length
      ? [
          `${t(`productionDeclarationDataFields.${field}`, { ns: 'common' })}: ${[...new Set(references)].join(', ')}`,
        ]
      : [];
  });
  return details.length ? details.join(' ; ') : undefined;
}
